












































































































































import SubscriptionConfig from '@/modules/subscription/components/SubscriptionConfig.vue';
import { deviceApi } from '../device.api';
import { RoleType } from '@shared/common/types';
import { subscriptionApi } from '@/modules/subscription/subscription.api';
import cloneDeep from 'lodash/cloneDeep';
import TagSelect from '@/modules/tag/components/TagSelect.vue';
import UserSelect from '@/modules/user/components/UserSelect.vue';
import { Device } from '../device';
import EditFormClass from '@/modules/core/components/EditForm';
import EditForm from '@/modules/core/components/EditForm.vue';
import { Component, Prop, Watch, Mixins } from 'vue-property-decorator';
import { DeviceFormModel } from '../device.form-model';
import { OfferType } from '@/shared/common/types/offer-type';
import { Subscription } from '../../subscription/subscription';
import { appService } from '../../../app.service';

@Component({
  components: {
    UserSelect,
    SubscriptionConfig,
    TagSelect,
    EditForm,
  },
})
export default class DeviceEdit extends Mixins(EditFormClass) {
  public subscriptions: Subscription[] = [];
  // selectedSubscription: null,
  // formErrors: [],
  // fetchedDevice: null,
  // RoleType,
  // pDevice: {
  //   info: {},
  //   customSubscriptionConfig: null,
  //   tag: null,
  //   owner: null,
  //   pinCode: null,
  // },

  public RoleType = RoleType;
  public entityCreatedMsg = 'Terminal créé';
  public entityUpdatedMsg = 'Terminal mis à jour';
  public formModelClass = DeviceFormModel;
  public formModel = new DeviceFormModel();
  public api = deviceApi;
  public offerTypes = Object.values(OfferType);
  public offerTypeFilter = OfferType.PTI;
  public OfferType = OfferType;
  public showCommentWarning = false;
  public commentWarningMsg = appService.commentWarningMsgHtml;

  @Prop({
    default: null,
  })
  public deviceId?: string;

  @Prop({ default: null })
  public device?: Device;

  @Prop({
    default: true,
  })
  public allowSave?: boolean;

  public get cardTitle(): string {
    return this.creation
      ? 'Nouveau terminal'
      : `Edition du terminal ${this.formModel.label}`;
  }

  public get entityId(): string | undefined {
    return this.deviceId;
  }

  public get creation(): boolean {
    return !this.formModel.id;
  }

  public get saveLabel(): string {
    return this.creation ? 'Créer' : 'Enregistrer';
  }

  public get subscriptionsFiltered(): Subscription[] {
    return this.subscriptions.filter(
      (sub: any) => sub.offerType === this.offerTypeFilter,
    );
  }

  public onTagInput(): void {
    this.formModel.tag = null;
  }

  public goBack(): void {
    this.$router.go(-1);
  }

  public async getSubscriptions(): Promise<void> {
    this.subscriptions = await subscriptionApi.findAll();
  }
  public regeneratePinCode(): void {
    // Make it reactive or the view won't update if field was empty
    this.$set(this.formModel, 'pinCode', Device.generatePinCode());
  }

  public onTagCancel(): void {
    delete this.formModel.tag;
  }

  public onUserCancel(): void {
    delete this.formModel.owner;
  }

  public onBaseSubscriptionChange(): void {
    this.formModel.baseSubscription =
      this.subscriptions.find(
        (s: any) => s.id === this.formModel.baseSubscriptionId,
      ) || null;

    if (!this.formModel.baseSubscription) {
      this.formModel.customSubscriptionConfig = null;
      return;
    }
    this.formModel.customSubscriptionConfig = cloneDeep(
      this.formModel.baseSubscription.config,
    );
  }

  @Watch('deviceId', { immediate: true })
  public async onDeviceIdChange(newVal: string): Promise<void> {
    if (newVal) {
      await this.getEntity();

      if (this.formModel.baseSubscription) {
        this.offerTypeFilter = this.formModel.baseSubscription.offerType;
      }
    } else {
      this.fetchedEntity = null;
    }
  }

  public mounted(): void {
    this.getSubscriptions();
  }
}
